import axios, { AxiosError, InternalAxiosRequestConfig } from "axios";
import authStorage from "../utils/authStorage";
import { Auth, CustomAxiosError, CustomAxiosType } from "../types/types";
import userStorage from "../utils/userStorage";
import CryptoJS from "crypto-js";
import qs from "qs";

// 운영계 테스트
// const baseURL =
//   `https://api.nongcall.com` +
//   (process.env.REACT_APP_ROUTE_ID
//     ? process.env.REACT_APP_ROUTE_ID
//     : "/nc");

const baseURL =
  process.env.REACT_APP_BASE_URL +
  (process.env.REACT_APP_ROUTE_ID
    ? process.env.REACT_APP_ROUTE_ID
    : "/nc");

export const client = axios.create({
  baseURL,
});

export const logOut = async (AuthExpired?: "AuthExpired") => {
  const uid = userStorage.get()?.id;
  if (uid != undefined) {
    authStorage.clear();
    userStorage.clear();
    localStorage.removeItem("name");
    localStorage.removeItem("image");
    localStorage.removeItem("MUTE");
    window.location.reload();
    if (AuthExpired) {
      window.alert(`로그인 정보가 만료되었습니다.`);
    }
  }
};

client.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = authStorage.get();
  config.headers = config.headers ?? {};
  if (token) {
    config.headers.Authorization = `Bearer ${token.accessToken}`;
  }

  if (config.method === "get") {
    // get일 때
    if (config.url?.includes("NB6T")) {
      return config;
    }
    const url = new URL(config.url as string, config.baseURL);
    const params = qs.parse(decodeURIComponent(url.search.slice(1)));
    for (const [key, value] of Object.entries(params)) {
      const encodedValue = CryptoJS.enc.Base64.stringify(
        CryptoJS.enc.Utf8.parse(value as string)
      );

      params[key] = isNaN(Number(value))
        ? encodeURIComponent(encodedValue)
        : encodedValue;
    }

    url.search = qs.stringify(params, { encode: false });
    config.url = url.toString();

    if (config.url && /\d+/.test(config.url)) {
      const encodedUrl = config.url.replace(/\/\d+/, (match) => {
        const encodedValue = CryptoJS.enc.Base64.stringify(
          CryptoJS.enc.Utf8.parse(match.substring(1))
        );
        return "/" + encodeURIComponent(encodedValue);
      });
      config.url = encodedUrl;
    }
  } else {
    // get이 아닐때
    if (
      config.url?.includes("Excel") ||
      // config.url?.includes("image") ||
      config.url?.includes("NB6T")
    ) {
      //config.headers["Content-Type"] = "multipart/form-data";
      return config;
    }
    if (config.url?.includes("image")) {
      config.headers["Content-Type"] = "multipart/form-data";
      // console.log(config);
      return config;
    }
    const requestBodyString = JSON.stringify(config.data);
    const encodedData = CryptoJS.enc.Base64.stringify(
      CryptoJS.enc.Utf8.parse(requestBodyString)
    );
    config.headers["Content-Type"] = "application/json";

    config.data = { paraJson: encodedData };
    if (config.url && /\d+/.test(config.url)) {
      const encodedUrl = config.url.replace(/\d+/, (match) => {
        const encodedValue = CryptoJS.enc.Base64.stringify(
          CryptoJS.enc.Utf8.parse(match)
        );
        return encodeURIComponent(encodedValue);
      });
      config.url = encodedUrl;
    }
  }

  return config;
});

let isRefreshing = false;
let isLoggingOut = false;

client.interceptors.response.use(
  function (response) {
    if (
      //response.config.url?.includes("Excel") ||
      //response.config.url?.includes("image") ||
      response.config.url?.includes("NB6T")
    ) {
      return response;
    }
    if (response.data && response.data.result) {
      const decodedResult = CryptoJS.enc.Base64.parse(
        response.data.result
      ).toString(CryptoJS.enc.Utf8);
      return {
        ...response,
        data: { ...response.data, result: JSON.parse(decodedResult) },
      };
    }
    return response;
  },

  async function (error: AxiosError<CustomAxiosError>) {
    const { config, response } = error;

    if (response?.data.code === 4001 && !config?.url?.includes("/login")) {
      const token = authStorage.get();
      // 리프레시 토큰 없거나 로그인 유지 체크 안함
      if (!token?.refreshToken || !userStorage.get()?.keepLoggedIn) {
        if (!isLoggingOut) {
          logOut("AuthExpired");
          isLoggingOut = true;
        }
        // logOut("AuthExpired");
      } else {
        if (!isRefreshing) {
          isRefreshing = true;
          try {
            const response = await client.post<CustomAxiosType<Auth>>(
              "/api/refreshNB6T",
              {
                accessToken: authStorage.get()?.accessToken,
                refreshToken: authStorage.get()?.refreshToken,
              }
            );
            const { accessToken, refreshToken } = response.data.result;
            authStorage.set({ accessToken, refreshToken });
            isRefreshing = false;
            return client.request(config!);
          } catch (err) {
            if (!isLoggingOut) {
              logOut("AuthExpired");
              isLoggingOut = true;
            }
          } finally {
            isRefreshing = false;
            isLoggingOut = false;
          }
        }
      }
      isLoggingOut = false;
    }

    return Promise.reject(error);
  }
);
